import { render, staticRenderFns } from "./conversation-messages.vue?vue&type=template&id=58b42035&scoped=true&"
import script from "./conversation-messages.vue?vue&type=script&lang=js&"
export * from "./conversation-messages.vue?vue&type=script&lang=js&"
import style0 from "./conversation-messages.vue?vue&type=style&index=0&id=58b42035&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b42035",
  null
  
)

export default component.exports